import axios from 'axios';
import qs from 'qs';
import { axiosConfig } from '../global';
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
const service = axios.create({
    baseURL: axiosConfig.baseUrl, // url = base url + request url
    timeout: axiosConfig.timeout, // request timeout
    withCredentials: true, // send cookies when cross-domain requests
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        // 'X-Requested-With': 'XMLHttpRequest',
    },
});

// request interceptor
const setInterceptors = (axiosInstance) => {
    axiosInstance.interceptors.request.use(
        (config) => {
            if (
                config.data &&
                (config.method || '').toLowerCase() === 'post' &&
                config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
            ) {
                config.data = qs.stringify(config.data);
            }
            return config;
        },
        (error) => {
            Toast(error.msg);
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (response) => {
            const res = response.data;
            res._headers = response.headers;
            if (!res.success) {
                Toast(res.info);
            }
            return res;
        },
        (error) => {
            // 网络错误，error.response为空，自定义网络错误信息
            // if (!error.response) {
            Toast.fail('网络错误');
            console.error(error);
            throw new Error('Network error!');
            //}
            //throw error;
        }
    );
};
setInterceptors(service);
export async function schoolRequest(config) {
    const resp = axios.create({
        baseURL: axiosConfig.schoolUrl, // url = base url + request url
        timeout: axiosConfig.timeout, // request timeout
        withCredentials: true, // send cookies when cross-domain requests
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
    setInterceptors(resp);
    return resp(config);
}
export async function YQRequest(config) {
    const resp = axios.create({
        baseURL: axiosConfig.YQUrl, // url = base url + request url
        timeout: axiosConfig.timeout, // request timeout
        withCredentials: true, // send cookies when cross-domain requests
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
    setInterceptors(resp);
    return resp(config);
}

export async function YAORequest(config) {
    const resp = axios.create({
        baseURL: axiosConfig.YaoUrl, // url = base url + request url
        timeout: axiosConfig.timeout, // request timeout
        withCredentials: true, // send cookies when cross-domain requests
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
    setInterceptors(resp);
    return resp(config);
}

export default async function assertAjax(config) {
    const resp = await service(config);
    return resp;
}
